import React, { useState, useCallback } from "react";
import "./With.css";
import axios from "axios";
import { useEffect } from "react";
import ContractDetails from "../../Contracts/ContractDetails";
import { Container, Row, Col } from "react-bootstrap";
import { ethers } from "ethers";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toastFailed, toastSuccess } from "../../Common/Data";
import {
  approveWithdrawalRequest,
  fetchAllTransaction,
  rejectWithdrawalRequest,
} from "../../Actions/adminActions";
import { useDispatch } from "react-redux";
import Tether from "../../Images/tether-usdt-logo.png";
import apiCall from "../../API/API";
import GetChainId from "../../Common/GetChainId";
import {
  useWalletClient,
  useAccount,
  useWaitForTransactionReceipt,
  useSendTransaction,
  useWriteContract,
  usePublicClient,
} from "wagmi";
import { parseUnits, encodeFunctionData } from "viem";
import GetUSDTBalance from "../../Common/GetUsdtBalance";
import ensureAllowance from "../../Common/ensureAllowance";
import Loader from "../../Component/Loader/Loader";
import { toast, ToastContainer } from "react-toastify";

const WithdrawnDetails = () => {
  const { BigInt } = window;
  const location = useLocation();
  // const account = useSelector((state) => state.accounts.value);
  const [usdt, setUsdt] = useState(false);
  const [atm, setAtm] = useState(false);
  const [show, setShow] = useState(false);
  const {
    amountArray = [],
    walletAddressArray = [],
    usernameArray = [],
    tx_IdsArray = [],
  } = location.state || {};
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedToken, setSelectedToken] = useState();
  const [companyDetails, setCompanyDetails] = useState();

  const { data: walletClient } = useWalletClient();
  const { address: account } = useAccount();
  const { writeContractAsync } = useWriteContract();
  const publicClient = usePublicClient();
  const [loading, setLoading] = useState(false);
  async function handleWithdraw() {
    try {
      if (!walletClient || !account) {
        toast.error("Please connect your wallet.");
        return;
      }

      if (
        !Array.isArray(amountArray) ||
        !Array.isArray(walletAddressArray) ||
        !Array.isArray(tx_IdsArray) ||
        amountArray.length === 0 ||
        amountArray.length !== walletAddressArray.length ||
        amountArray.length !== tx_IdsArray.length
      ) {
        toast.error("Invalid withdrawal request data. Arrays must have the same length.");
        return;
      }

      setLoading(true);

      // Parse each amount to token decimals (adjust if token is 6 decimals)

      const parsedAmounts = amountArray?.map((amt) => {
        const parsed = parseUnits(amt.toString(), 18); // returns bigint
        // console.log("amount", amt);
        // console.log("parsedAmount", parsed.toString()); // ✅ safe
        return parsed;
      });

      // console.log(
      //   "Parsed Amounts:",
      //   parsedAmounts.map((a) => a.toString()) // ✅ all safe
      // );

      // Convert txids to BigInt (uint256 in Solidity)
      const parsedTxIds = tx_IdsArray?.map((txid) => {
        return BigInt(txid);
      });

      // console.log("Parsed TX IDs:", parsedTxIds.map((id) => id.toString()));

      // Calculate total amount for allowance
      const totalAmount = parsedAmounts.reduce((acc, a) => acc + a, 0n);
      // console.log("Total Amount:", totalAmount.toString());

      // 1) Ensure safe allowance for contract
      const allowanceOk = await ensureAllowance({
        account,
        publicClient,
        walletClient,
        token: ContractDetails.BUSD,
        spender: ContractDetails.contract,
        amount: totalAmount,
      });

      if (!allowanceOk) {
        toast.error("Allowance failed.");
        return;
      }

      // 2) Simulate sendTokenToMultipleAddresses
      const { request, result } = await publicClient.simulateContract({
        abi: ContractDetails.contractABI,
        address: ContractDetails.contract,
        functionName: "sendUSDTToMultipleAddresses",
        // functionName: "sendTokenToMultipleAddresses",
        args: [parsedAmounts, walletAddressArray, parsedTxIds],
        account,
        value: 0n,
      });

      // Extract and console return values from contract
      const processedCount = result[0];
      const duplicateTxIds = result[1] || [];
      const duplicateBlockNumbers = result[2] || [];
      
      // console.log("=== Contract Return Values ===");
      // console.log("Total TxIds:", tx_IdsArray.length);
      // console.log("processedCount (uint256):", processedCount?.toString());
      // console.log("duplicateTxIds[] (uint256[]):", duplicateTxIds.map((id) => id.toString()));
      // console.log("duplicateBlockNumbers[] (uint256[]):", duplicateBlockNumbers.map((bn) => bn.toString()));
      // console.log("Non-duplicate count:", tx_IdsArray.length - duplicateTxIds.length);

      // Store duplicate info map: txid -> { originalTxHash, originalBlockNumber }
      const duplicateInfoMap = new Map();

      // Step 1: Fetch transaction hash for duplicate txids using block numbers from contract
      if (duplicateTxIds.length > 0) {
        // console.log("=== Fetching Original Transaction Hash for Duplicates ===");
        // console.log(`=== Using block numbers from contract (no need to query all events) ===`);
        
        // Create map: txid -> blockNumber from contract return values
        const txidToBlockNumber = new Map();
        for (let i = 0; i < duplicateTxIds.length; i++) {
          const txid = duplicateTxIds[i].toString();
          const blockNumber = duplicateBlockNumbers[i];
          txidToBlockNumber.set(txid, blockNumber);
          // console.log(`Duplicate txid ${txid} was first used at block ${blockNumber?.toString()}`);
        }
        
        try {
          // Find TransferEntry event from contract ABI
          const transferEntryEvent = ContractDetails.contractABI.find(
            (item) => item.type === "event" && item.name === "TransferEntry"
          );

          if (!transferEntryEvent) {
            console.error("TransferEntry event not found in contract ABI");
            throw new Error("TransferEntry event not found");
          }

          // Query TransferEntry events at specific block numbers (query small ranges around each block)
          // This is much more efficient than querying all events
          const allLogs = [];
          const maxQueryRange = 50000n; // RPC limit
          
          // Group block numbers into query ranges
          const blockRanges = new Map(); // fromBlock -> toBlock
          for (const [txid, blockNumber] of txidToBlockNumber.entries()) {
            if (!blockNumber || blockNumber === 0n) {
              console.warn(`⚠️ No block number for txid ${txid}, skipping`);
              continue;
            }
            
            // Query a small range around the block (e.g., ±10 blocks to be safe)
            const fromBlock = blockNumber > 10n ? blockNumber - 10n : 0n;
            const toBlock = blockNumber + 10n;
            
            // Check if this range overlaps with existing ranges
            let merged = false;
            for (const [existingFrom, existingTo] of blockRanges.entries()) {
              if (fromBlock <= existingTo && toBlock >= existingFrom) {
                // Merge ranges
                const newFrom = fromBlock < existingFrom ? fromBlock : existingFrom;
                const newTo = toBlock > existingTo ? toBlock : existingTo;
                blockRanges.delete(existingFrom);
                blockRanges.set(newFrom, newTo);
                merged = true;
                break;
              }
            }
            
            if (!merged) {
              blockRanges.set(fromBlock, toBlock);
            }
          }
          
          // console.log(`=== Querying ${blockRanges.size} block range(s) for TransferEntry events ===`);
          
          // Query each range
          for (const [fromBlock, toBlock] of blockRanges.entries()) {
            try {
              const logs = await publicClient.getLogs({
                address: ContractDetails.contract,
                event: transferEntryEvent,
                fromBlock: fromBlock,
                toBlock: toBlock,
              });
              allLogs.push(...logs);
              // console.log(`✅ Queried blocks ${fromBlock.toString()} to ${toBlock.toString()}: Found ${logs.length} events`);
            } catch (error) {
              console.warn(`⚠️ Failed to query blocks ${fromBlock.toString()} to ${toBlock.toString()}:`, error.message);
            }
          }
          
          // console.log(`=== Total TransferEntry events found: ${allLogs.length} ===`);
          
          // Match txids with their original transaction hashes
          for (const log of allLogs) {
            const txid = log.args.txid?.toString();
            const expectedBlockNumber = txidToBlockNumber.get(txid);
            
            if (txid && expectedBlockNumber) {
              const logBlockNumber = log.blockNumber || 0n;
              
              // Verify this event is at the expected block (or close to it)
              if (logBlockNumber >= expectedBlockNumber - 10n && logBlockNumber <= expectedBlockNumber + 10n) {
                if (!duplicateInfoMap.has(txid)) {
                  duplicateInfoMap.set(txid, {
                    originalTxHash: log.transactionHash,
                    originalBlockNumber: log.args.blockNumber?.toString() || logBlockNumber.toString(),
                  });
                  // console.log(`✅ Found ORIGINAL Duplicate TxId: ${txid}`);
                  // console.log(`  Original Transaction Hash: ${log.transactionHash}`);
                  // console.log(`  Original Block Number: ${log.args.blockNumber?.toString() || logBlockNumber.toString()}`);
                  // console.log(`  Event Block Number: ${logBlockNumber.toString()}`);
                }
              }
            }
          }
          
          // console.log(`=== Found ${duplicateInfoMap.size} duplicate transaction hashes ===`);
          
          // Log any missing txids
          for (const [txid, blockNumber] of txidToBlockNumber.entries()) {
            if (!duplicateInfoMap.has(txid)) {
              console.warn(`⚠️ Could not find TransferEntry event for txid ${txid} at block ${blockNumber.toString()}`);
            }
          }
        } catch (error) {
          console.error("❌ Error fetching events for duplicates:", error);
          console.error("Error details:", {
            message: error?.message,
            shortMessage: error?.shortMessage,
            code: error?.code,
            name: error?.name,
          });
          toast.error("Failed to fetch duplicate transaction info. Proceeding with filtered execution.");
        }
      }

      // Step 2: Filter arrays to remove duplicates (keep only non-duplicates for execution)
      const duplicateTxIdsSet = new Set(duplicateTxIds.map((id) => id.toString()));
      const filteredArrays = {
        amounts: [],
        addresses: [],
        txIds: [],
        originalIndices: [], // Track original indices for mapping back
      };

      // Filter out duplicates, keep only non-duplicates
      for (let i = 0; i < parsedAmounts.length; i++) {
        const txidStr = parsedTxIds[i].toString();
        if (!duplicateTxIdsSet.has(txidStr)) {
          filteredArrays.amounts.push(parsedAmounts[i]);
          filteredArrays.addresses.push(walletAddressArray[i]);
          filteredArrays.txIds.push(parsedTxIds[i]);
          filteredArrays.originalIndices.push(i);
        }
      }

      // console.log("=== Filtered Arrays for Execution ===");
      // console.log(`Original count: ${parsedAmounts.length}`);
      // console.log(`Filtered count (non-duplicates): ${filteredArrays.amounts.length}`);
      // console.log(`Duplicates removed: ${duplicateTxIds.length}`);

      // Step 3: Re-simulate with filtered arrays (only non-duplicates)
      let finalRequest = request;
      let currentTxHash = null;
      let transactionFailed = false;
      let transactionError = null;

      if (filteredArrays.amounts.length > 0) {
        // Re-simulate with filtered arrays
        const { request: filteredRequest } = await publicClient.simulateContract({
          abi: ContractDetails.contractABI,
          address: ContractDetails.contract,
          functionName: "sendUSDTToMultipleAddresses",
          args: [filteredArrays.amounts, filteredArrays.addresses, filteredArrays.txIds],
          account,
          value: 0n,
        });
        finalRequest = filteredRequest;

        // Step 4: Execute transaction only for non-duplicates
        // console.log("=== Executing Transaction (Non-duplicates only) ===");
        try {
          currentTxHash = await walletClient.writeContract(finalRequest);
          // console.log("Current Transaction Hash:", currentTxHash);

          const receipt = await publicClient.waitForTransactionReceipt({
            hash: currentTxHash,
          });

          if (receipt.status !== "success") {
            transactionFailed = true;
            transactionError = "Transaction receipt status is not success";
            console.error("Transaction failed:", transactionError);
            toast.error("Withdrawal transaction failed. Processing duplicates only.");
          } else {
            // console.log("Transaction successful!");
          }
        } catch (error) {
          transactionFailed = true;
          transactionError = error?.message || error?.shortMessage || "Transaction execution failed";
          console.error("Transaction execution error:", error);
          toast.error(`Transaction failed: ${transactionError}. Processing duplicates only.`);
        }
      } else {
        console.warn("All txids are duplicates. No transaction to execute.");
        toast.warning("All transaction IDs are duplicates. No new transaction executed.");
      }

      // Step 5: Prepare data for backend - All txids with their respective hashes
      const txidHashMapping = [];

      // Add non-duplicates with current transaction hash (only if transaction was successful)
      if (currentTxHash && !transactionFailed) {
        for (let i = 0; i < filteredArrays.originalIndices.length; i++) {
          const originalIndex = filteredArrays.originalIndices[i];
          txidHashMapping.push({
            txid: tx_IdsArray[originalIndex],
            txHash: currentTxHash,
            isDuplicate: false,
          });
        }
      }

      // Add duplicates with their original transaction hash (only those with found hash)
      for (const duplicateTxId of duplicateTxIds) {
        const txidStr = duplicateTxId.toString();
        const duplicateInfo = duplicateInfoMap.get(txidStr);
        // Only add if tx hash was found
        if (duplicateInfo?.originalTxHash) {
          txidHashMapping.push({
            txid: txidStr,
            txHash: duplicateInfo.originalTxHash,
            isDuplicate: true,
            originalBlockNumber: duplicateInfo.originalBlockNumber || null,
          });
        } else {
          console.warn(`Skipping duplicate txid ${txidStr}: No original transaction hash found`);
        }
      }

      // console.log("=== Final Mapping: TxIds with Their Hashes ===");
      // console.log("Total entries:", txidHashMapping.length);
      // console.log("Non-duplicates (current txHash):", txidHashMapping.filter((m) => !m.isDuplicate).length);
      // console.log("Duplicates (original txHash):", txidHashMapping.filter((m) => m.isDuplicate).length);
      // console.log("Complete mapping:", txidHashMapping);

      // Step 6: Update backend with txids and their respective hashes
      // Group by hash for efficient API call
      const hashGroups = new Map();
      for (const mapping of txidHashMapping) {
        const hash = mapping.txHash;
        if (hash && hash !== "pending" && hash !== null) {
          if (!hashGroups.has(hash)) {
            hashGroups.set(hash, []);
          }
          hashGroups.get(hash).push(mapping.txid);
        }
      }

      // Update backend for each hash group
      let successCount = 0;
      let duplicateCount = 0;
      for (const [hash, txids] of hashGroups.entries()) {
        if (hash && hash !== "pending" && hash !== null) {
          // console.log(`Updating backend: ${txids.length} txids with hash ${hash}`);
          try {
            await dispatch(approveWithdrawalRequest(txids, hash));
            // Count successful vs duplicates
            const isDuplicateGroup = txidHashMapping.some(m => m.txid === txids[0] && m.isDuplicate);
            if (isDuplicateGroup) {
              duplicateCount += txids.length;
            } else {
              successCount += txids.length;
            }
          } catch (error) {
            console.error(`Failed to update backend for hash ${hash}:`, error);
            toast.error(`Failed to update ${txids.length} transaction(s) in backend.`);
          }
        }
      }

      // Calculate skipped duplicates (those without found hash)
      const skippedDuplicates = duplicateTxIds.length - duplicateCount;
      if (skippedDuplicates > 0) {
        console.warn(`${skippedDuplicates} duplicate txid(s) skipped: No original transaction hash found`);
        toast.warning(`${skippedDuplicates} duplicate txid(s) could not be mapped to original transaction hash.`);
      }
      
      // Show appropriate success/error message
      if (transactionFailed) {
        if (duplicateCount > 0) {
          toast.warning(`Transaction failed, but ${duplicateCount} duplicate(s) were processed. ${successCount} non-duplicate(s) failed.`);
        } else {
          toast.error(`Transaction failed. No duplicates could be processed.`);
        }
      } else {
        toast.success(`Withdrawal successful`);
      }

      // Navigate after toasts are displayed (delay to ensure toasts are visible)
      setTimeout(() => {
        navigate("/dashboard/withdraw_controls");
      }, 2000);
    } catch (error) {
      console.error("Withdrawal failed:", error);
      const message =
        error?.shortMessage || error?.message || "Transaction failed.";

      if (error?.code === "TIMEOUT") {
        toast.error("Transaction timeout. Check your wallet.");
      } else if (
        message.toLowerCase().includes("simulation") ||
        message.toLowerCase().includes("gas")
      ) {
        toast.error("Gas/simulation failed. Check token decimals & args.");
      } else if (error?.code === 4001 || error?.code === "ACTION_REJECTED") {
        toast.error("Transaction rejected by user.");
      } else {
        toast.error(message);
      }
    } finally {
      setLoading(false);
    }
  }
  const handleToken = (token) => {
    // console.log("token details", token);
    setSelectedToken(token);
    setShow(false);
  };

  useEffect(() => {
    if (selectedToken) {
      // console.log("token is selected!");
      // console.log("amountArray", amountArray);
      // console.log("walletAddressArray", walletAddressArray);
      handleWithdraw();
    }
  }, [selectedToken]);

  const handleNotWithDap = () => {
    navigate("/dashboard/withdraw_controls");
  };

  const getCompanyDetails = async () => {
    try {
      const res = await apiCall("GET", "/get-company-info");
      // console.log("company details", res);
      setCompanyDetails(res?.data?.company_info);
    } catch (error) {
      console.error(error.message);
    }
  };

  var x = 0;
  useEffect(() => {
    if (x == 0) {
      getCompanyDetails();
      x++;
    }
  }, []);

  return (
    <React.Fragment>
      {loading ? <Loader /> : null}
      <Container>
        {show && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h2>Select Token For Withdrawal</h2>
              <div className="tokenSelection">
                {companyDetails?.tokens
                  ?.filter((token) => token.enabled === 1)
                  ?.map((token, i) => (
                    <div
                      key={i}
                      className="tokenDiv"
                      onClick={() => handleToken(token)}
                    >
                      <span>{token?.tokenName}</span>
                      {token?.token_image?.startsWith("<svg") ? (
                        <span
                          style={{ marginLeft: "5px" }}
                          dangerouslySetInnerHTML={{
                            __html: token?.token_image,
                          }}
                        />
                      ) : (
                        <img
                          src={token?.token_image}
                          alt={token?.tokenSymbol}
                          style={{ marginLeft: "5px", height: "40px" }}
                        />
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}
        <div id="directIncomeDiv">
          <div className="button-container">
            <button
              className="action-btn"
              // onClick={() => setShow(true)}
              onClick={handleWithdraw}
            >
              Proceed
            </button>
            <button className="action-btn" onClick={handleNotWithDap}>
              Cancel
            </button>
          </div>

          <Row id="directTableRow" className="text-center">
            <Col md="12" className="p-0">
              <div style={{ width: "100%", display: "flex" }}>
                <table>
                  <tr>
                    <th>S. No.</th>
                    <th>Username</th>
                    <th>Wallet Address</th>
                    <th>Amount</th>
                  </tr>
                  <tbody>
                    {amountArray.map((amount, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{usernameArray[i]}</td>
                        <td>{walletAddressArray[i]}</td>
                        <td>{amount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        </div>
        <ToastContainer />
      </Container>
    </React.Fragment>
  );
};

export default WithdrawnDetails;
